import * as React from "react";
import { useCallback, useState } from "react";
import union from "lodash/union";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import ParameterDeclarationForm from "enterprise/parameters/components/ParameterDeclarationForm";
import { Button } from "components/bootstrap";
import createParametersFromNames from "enterprise/parameters/components/CreateParametersFromNames";
import useParameterDeclarationContext from "search-filter/hooks/useParameterDeclarationContext";
import useViewsDispatch from "views/stores/useViewsDispatch";
import { declareParameters } from "views/logic/slices/searchExecutionSlice";
import useParametersMap from "views/hooks/useParametersMap";
import useUndeclaredParameters from "enterprise/parameters/components/useUndeclaredParameters";
const QueryValidationParameterDeclaration = ({ validationState = void 0 }) => {
  var _a;
  const { t } = useTranslation("enterprise_common");
  const [showDeclarationForm, setShowDeclarationForm] = useState(false);
  const parameterDeclarationContext = useParameterDeclarationContext();
  const existingParameters = useParametersMap();
  const undeclaredParameterNamesFromSearch = useUndeclaredParameters();
  const dispatch = useViewsDispatch();
  const { submitForm } = useFormikContext();
  const toggleDeclarationForm = useCallback(() => {
    setShowDeclarationForm((cur) => !cur);
  }, []);
  const parameterValidationErrors = (_a = validationState == null ? void 0 : validationState.explanations) == null ? void 0 : _a.filter(
    (explanation) => explanation.errorType === "UNDECLARED_PARAMETER"
  );
  const undeclaredParameterNamesFromValidation = parameterValidationErrors == null ? void 0 : parameterValidationErrors.flatMap(({ relatedProperty }) => relatedProperty).filter((paramName) => !!paramName);
  const undeclaredParameterNames = union(
    undeclaredParameterNamesFromSearch.toArray(),
    undeclaredParameterNamesFromValidation
  );
  const onSaveParameters = useCallback(
    (parameters) => dispatch(declareParameters(parameters)).then(() => {
      const onSaveParametersSuccess = parameterDeclarationContext == null ? void 0 : parameterDeclarationContext.onSaveParametersSuccess;
      if (onSaveParametersSuccess) {
        onSaveParametersSuccess({ toggleDeclarationForm });
      } else {
        submitForm();
      }
    }),
    [dispatch, parameterDeclarationContext == null ? void 0 : parameterDeclarationContext.onSaveParametersSuccess, submitForm, toggleDeclarationForm]
  );
  if (!(undeclaredParameterNames == null ? void 0 : undeclaredParameterNames.length)) {
    return null;
  }
  const undeclaredParameters = createParametersFromNames(undeclaredParameterNames);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "small", onClick: toggleDeclarationForm }, t("parameters.declare")), showDeclarationForm && /* @__PURE__ */ React.createElement(
    ParameterDeclarationForm,
    {
      existingParameters,
      parameters: undeclaredParameters,
      onClose: toggleDeclarationForm,
      onSave: onSaveParameters
    }
  ));
};
export default QueryValidationParameterDeclaration;
